module.exports = __webpack_public_path__ + "img/tree-sml-bubble.4fda06f4.svg";